<template>
    <div class="pagination">
        <el-pagination
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :page-sizes="pageSizesArr"
            :total="total"
            :current-page="currentPage"
            :page-size="pageSize"
            :layout="layout"
        ></el-pagination>
    </div>
</template>
 
<script>
export default {
    name: "Pagination",
    props: {
        // 总页数
        total: {
            type: Number,
            default: 0,
        },
        // 当前页
        currentPage: {
            type: Number,
            default: 1,
        },
        // 每页显示条数
        pageSize: {
            type: Number,
            default: 10,
        },
        // 可切换每页显示条数,可自由设置
        pageSizesArr: {
            type: Array,
            default() {
                return [5, 10, 15, 20];
            },
        },
        layout: {
            type: String,
            default: "total,  prev, pager, next, sizes, jumper",
        },
    },
    data() {
        return {
            page: {
                _pageSize: this.pageSize,
                _currentPage: this.currentPage,
            },
        };
    },
    methods: {
        //  每页查看条数变化
        handleSizeChange(val) {
            this.page._pageSize = val;
            this.$emit("pageChange", this.page);
        },
        // 当前页码变化
        handleCurrentChange(val) {
            this.page._currentPage = val;
            this.$emit("pageChange", this.page);
        },
    },
};
</script>
 
<style scoped lang="scss">
/* .pagination {
  margin-top: 30px !important;
  /deep/ .el-pagination {
    text-align: center;
  }
} */
.el-pagination {
    display: flex;
    justify-content: center;
    margin-top: 10px;
}
</style>